
    <div class="row account p-2 m-2">
        <form [formGroup]="addInvoiceForm">
            <div class="row account">
                <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                   <div class="d-flex align-items-center justify-content-between">
                        <h4 class="text-dark fw-bold mb-0 ">Add Invoice Details </h4>
                        <button class="btn shadow-none" mat-dialog-close><i class="fa-solid fa-xmark"></i></button>
                   </div>
                </div>
                <div>
                    <div class="row">
                        <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                            <div class="form-group accountsinp  mb-3">
                                <label for="">Invoice No<sup class="text-danger">*</sup></label>
                                <div class="d-flex align-items-center">
                                    <input type="text" class="form-control me-1 shadow-none" placeholder="Enter Invoice No"
                                        id="InvoiceNoctrl" formControlName="InvoiceNo">
                                </div>
                                  <small class="text-danger" *ngIf="ff.InvoiceNo.touched && ff.InvoiceNo.errors?.['required']">
        Invoice Number is required
      </small>
      <small class="text-danger" *ngIf="ff.InvoiceNo.touched && ff.InvoiceNo.errors?.['pattern']">
        Only numbers are allowed
      </small>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                            <div class="form-group accountsinp  mb-3">
                                <label for="">Invoice Value<sup class="text-danger">*</sup></label>
                                <div class="d-flex align-items-center">
                                    <input type="text" class="form-control me-1 shadow-none"
                                        placeholder="Enter Invoice Value" id="InvoiceValuectrl"
                                        formControlName="InvoiceValue">
                                </div>
                                 <small class="text-danger" *ngIf="ff.InvoiceValue.touched && ff.InvoiceValue.errors?.['required']">
        Invoice Value is required
      </small>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                            <div class="form-group accountsinp  mb-3">
                                <label for="">Number of Articles<sup class="text-danger">*</sup></label>
                                <div class="d-flex align-items-center">
                                    <input type="text" class="form-control me-1 shadow-none"
                                        placeholder="Enter No. of Article" id="NoofArticlectrl"
                                        formControlName="NoofArticle">
                                </div>
                                 <small class="text-danger" *ngIf="ff.NoofArticle.touched && ff.NoofArticle.errors?.['required']">
        Number of Articles is required
      </small>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                            <div class="form-group accountsinp  mb-3">
                                <label for="">Weight<sup class="text-danger">*</sup></label>
                                <div class="d-flex align-items-center">
                                    <input type="text" class="form-control me-1 shadow-none"
                                        placeholder="Enter Weight Value" id="Weightctrl" formControlName="Weight">
                                    <!-- <input type="hidden" class="form-control me-1 shadow-none"  id="vIdctrl" formControlName="vId"> -->
    
                                </div>
                                 <small class="text-danger" *ngIf="ff.Weight.touched && ff.Weight.errors?.['required']">
        Weight is required
      </small>
      <small class="text-danger" *ngIf="ff.Weight.touched && ff.Weight.errors?.['pattern']">
        Enter a valid weight (e.g. 10 or 10.5)
      </small>
                            </div>
                        </div>
                        <!-- <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                         <div class="form-group accountsinp  mb-3">
                             <label for="">Freight</label>
                             <div class="d-flex align-items-center">
                                 <input type="text" class="form-control me-1 shadow-none" placeholder="Enter Freight Value" id="Frieghtctrl" formControlName="Frieght">
                                
                             </div>
                         </div>
                        </div> -->
                        <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                            <div class="form-group accountsinp  mb-3">
                                <label for=""> Customer Name <sup class="text-danger">*</sup></label>
                                <div class="d-flex align-items-center">
                                    <input type="text" class="form-control me-1 shadow-none"
                                        placeholder="Enter Customer Name" id="customerNamectrl"
                                        formControlName="customerName">
                                </div>
                                 <small class="text-danger" *ngIf="ff.customerName.touched && ff.customerName.errors?.['required']">
        Customer Name is required
      </small>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                            <div class="form-group accountsinp  mb-3">
                                <label for="">Invoice Attachment</label>
                                <div class="d-flex align-items-center justify-content-center">
                                    <input type="file" accept="image/*,.pdf,.doc" (change)="fileChangeEventAttachment($event)"
                                        class="form-control me-1 shadow-none" id="PODctrl" formControlName="POD">
                                    <button class="btn btn-dark btn-sm  px-4 ms-3" type="button" (click)="preview()" mat-raised-button >Preview</button>
                                    <a #showPreview [href]="previewURL" target="_blank"></a>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                        <div class="form-group accountsinp  mb-3">
                            <label for="">Invoice Attachment</label>
                            <div class="d-flex align-items-center">
                                <input type="file" accept="image/*" (change)="fileChangeEventAttachment($event)" class="form-control me-1 shadow-none" id="PODctrl" formControlName="POD">
                            </div>
                        </div>
                    </div> -->
                        <div class="col-xl-12 col-md-12 col-12 col-sm-12 text-end">
                            <button mat-raised-button [mat-dialog-close]="true" class="btn btn-outline-dark me-1 ">Cancel</button>
                            <button mat-raised-button (click)="addInvoice()" class="btn btn-dark ms-1" type="submit">Add Invoice</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
